module.exports = __webpack_public_path__ + "img/mount-of-firelogo2.bada0cf8.png";